import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../Loading/Loading";
import ShowCard from "../ShowCard/ShowCard";
import * as service from "./service";
import { useWindowWidth } from "@react-hook/window-size";
import { isHTML, rowItemCount } from "../../utils/utils";
import useScrollPosition from "../ScrollPosition/useScrollPosition";
import MagazineCard from "../MagazineCard/MagazineCard";
import GaiaCard from "../ShowCard/GaiaCard";
import Translate from "../Multilanguage/Translate";
import OurSports from "../../Screens/OurSports/OurSports";
import FlsLandingPage from "../../Screens/FlsLandingPage/FlsLandingPage";
import SportsPage from "../../Screens/Sports/SportsPage";

const CommonPage = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);

  const { careers, partnerId: partnerIdParam } = useParams();
  const pubid = Number(projectInfo?.projectConfig?.pubid);

  const [shows, setShows] = useState([]);
  const [img, setImg] = useState(true);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [rowItemsClass, setRowItemsClass] = useState("")
  const [sliceCount, setSliceCount] = useState(20)
  const [isExpanded, setIsExpanded] = useState(false);
  const [partner, setPartner] = useState(null);
  const [noDataMessage, setNoDataMessage] = useState("");
  const isPartnerPage = Boolean(partnerIdParam);
  const partnerId = partnerIdParam;

  const type = location?.state?.type;
  const thumbnailOrientation = shows?.thumbnail_orientation ? shows?.thumbnail_orientation : location?.state?.thumbnailOrientation ? location?.state?.thumbnailOrientation : projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION;
  const navigate = useNavigate();
  const windowSize = useWindowWidth()
  const containerRef = useRef(null)
  const scrollPosition = useScrollPosition();
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const theme = projectInfo?.projectConfig?.config?.THEME;

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  // useEffect(() => {
  //   // if (menuItem) {
  //   fetchCategoryDetails();
  //   // } else {
  //   //   fetchCategoryDetails();
  //   // }
  // }, [location]);

  useEffect(() => {
    if (pubid === 50183 && (careers === "our-sports" || careers === "oursports" || careers === "our-sports-list" || careers === "sports" || careers === "action-extreme-sports" || careers === "action-sports" || careers === "ways-to-watch" || careers === "watch-on-mobile" || careers === "watch-on-tv" || careers === "faqs" || careers === "landing" || careers === "fls-landing")) {
      return;
    }
    if (isPartnerPage && partnerId) {
      fetchPartnerDetails();
    } else {
      fetchCategoryDetails();
    }
  }, [location.pathname, partnerId, careers, pubid]);

  const fetchPartnerDetails = async () => {
    try {
      const response = await service.getPartnerDetails(appInfo, partnerId);
      if (response?.status === 200) {
        setPartner(response?.data?.data);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || <Translate textKey={"no_data_found"} />, {
        position: "top-center",
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!loading && sliceCount < shows?.shows?.length) {
      lazyLoad()
    }
  }, [loading, scrollPosition, shows])

  useEffect(() => {
    if (windowSize > 980) {
      if (projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) {
        setRowItemsClass(rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT))
      } else {
        setRowItemsClass("rowCount4")
      }
    } else {
      setRowItemsClass("")
    }
  }, [projectInfo, windowSize]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const fetchCategoryDetails = async () => {
    setLoading(true)
    setNoDataMessage("");
    try {
      const itemResponse = await service.getAllShowsOfCategory(appInfo, careers);
      if (itemResponse?.status === 200) {
        setShows(itemResponse?.data?.data);
        setNoDataMessage(itemResponse?.data?.message || itemResponse?.data?.data?.message || "");
        setImg(false);
        setLoading(false)
      }
    } catch (err) {
      setNoDataMessage(err?.response?.data?.message || "");
      toast.error(err?.response?.data?.message, {
        position: "top-center",
      });
      setLoading(false)

    }
  };

  const lazyLoad = () => {
    const containerHeight = containerRef?.current?.clientHeight;
    if (scrollPosition + 2200 >= containerHeight) {
      setSliceCount(sliceCount + 20)
    }
  }

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  if (pubid === 50183) {
    if (careers === "action-extreme-sports" || careers === "action-sports") {
      return <SportsPage pageKey="action-extreme-sports" />;
    }
    if (careers === "our-sports" || careers === "oursports" || careers === "our-sports-list" || careers === "sports") {
      return <OurSports />;
    }
    if (careers === "ways-to-watch" || careers === "watch-on-mobile" || careers === "watch-on-tv" || careers === "faqs" || careers === "landing" || careers === "fls-landing" || careers === "free-live-sports") {
      return <FlsLandingPage />;
    }
  }

  if (loading) {
    return (
      <Loading />
    )
  }

  return (
    <>
      <div className={`commonPage ${isRTL ? "rtl" : ""} ${template === "TEMPLATE_12" ? "kids" : ""} ${template === "TEMPLATE_10" ? (shows?.banner ? "gaia" : "gaia-banner") : ""}`} ref={containerRef} role="region" aria-label="Common Page Section">
        <ToastContainer />

        {isPartnerPage && partner ? (
          <>
            <div className="partner-banner" role="region" aria-label="Partner Banner">
              <img className="partner-avatar" src={partner?.image} alt={partner?.name} />
              <span className="title">{partner?.name}</span>
              <div className="partner-desc" dangerouslySetInnerHTML={{ __html: partner?.description }} />
            </div>
            <div className="wrapper">
              <div className="bottom">
                <div className="itemsContainer" aria-label="Partner Shows">
                  {partner?.shows && partner?.shows?.length > 0 ? (
                    partner.shows.map((item, index) => (
                      <div className={`items landscape ${rowItemsClass}`} key={item?.show_id || index}>
                        {template === "TEMPLATE_10" ? (
                          <GaiaCard
                            data={item}
                            imageUrl={img}
                            season={false}
                            metaData={true}
                            type={type}
                            thumbnailOrientation={thumbnailOrientation}
                            categoryName={shows?.category_name}
                            tabIndex={0}
                            role="button"
                            aria-label={item?.show_title || "Show"}
                          />
                        ) : (
                          <ShowCard
                            data={item}
                            imageUrl={img}
                            season={false}
                            metaData={true}
                            type={type}
                            thumbnailOrientation={thumbnailOrientation}
                            categoryName={shows?.category_name}
                            tabIndex={0}
                            role="button"
                            aria-label={item?.show_title || "Show"}
                          />
                        )}
                      </div>
                    ))
                  ) : (
                    <h1 style={{ color: "#E72A31", display: "flex", justifyContent: "center" }} role="alert" aria-live="assertive">
                      <Translate textKey={"no_data_found"} />
                    </h1>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          shows?.shows?.length === 0 | Object.entries(shows).length === 0 ? (
            <h1
              style={{
                color: "#E72A31",
                display: "flex",
                justifyContent: 'center',
                padding: '100px',
              }}
              className={`${template === "TEMPLATE_10" ? "gaia" : "no-data"}`}
              role="alert"
              aria-live="assertive"
            >
              {noDataMessage || <Translate textKey={'no_data_found'} />}
            </h1>
          ) : (
            <>
              {shows?.banner ? (
                <div
                  className={`${(projectInfo?.projectConfig?.pubid === 50146 || ((template === "TEMPLATE_9" || template === "TEMPLATE_12") && !isExpanded)) ? 'bannerContainer' : 'bgImageContainer'}`}
                  style={{
                    backgroundImage: (template === "TEMPLATE_9" || template === "TEMPLATE_12")
                      ? `linear-gradient(90deg, #000 0%, transparent), url(${shows?.banner})`
                      : `url(${shows?.banner})`,

                  }}
                >
                  <div className="topContainer">
                    <div className={(template === "TEMPLATE_9" || template === "TEMPLATE_12") ? "topbanner" : "top"}>
                      <h1 className={`heading  ${template === "TEMPLATE_10" ? "gaia" : ""}  ${theme === "LIGHT" ? (shows?.banner ? "light-theme" : "light-noBg") : ""} `}> {[50158, 50157].includes(projectInfo?.projectConfig?.pubid) ? shows?.category_name : ""}</h1>
                      {/* <p className="desc">{shows?.synopsis}</p> */}
                      <p className="desc">
                        {/* {(template !== "TEMPLATE_9" && template !== "TEMPLATE_12") ? shows?.synopsis : isExpanded || shows?.synopsis?.split(" ").length <= 70
                      ? shows?.synopsis
                      : `${shows?.synopsis?.split(" ").slice(0, 70).join(" ")}...`} */}
                        {(() => {
                          const rawSynopsis = shows?.synopsis || "";
                          const synopsis = (template !== "TEMPLATE_9" && template !== "TEMPLATE_12")
                            ? rawSynopsis
                            : isExpanded || rawSynopsis.split(" ").length <= 70
                              ? rawSynopsis
                              : `${rawSynopsis.split(" ").slice(0, 70).join(" ")}...`;
                          if (isExpanded && isHTML(synopsis)) {
                            return <span dangerouslySetInnerHTML={{ __html: synopsis }} />;
                          }
                          return (
                            (template === "TEMPLATE_9" || template === "TEMPLATE_12") ? (
                              <span className="desc"
                                dangerouslySetInnerHTML={{
                                  __html: (synopsis || "").replace(/<br\s*\/?>/gi, "\n").replace(/<\/p>/gi, "\n").replace(/<[^>]+>/g, "").replace(/\n+/g, "\n")
                                }}
                              />
                            ) : (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: (synopsis || "").replace(/\n/g, "<br>")
                                }}
                              />
                            )
                          );
                        })()}
                        {!isExpanded && (template === "TEMPLATE_9" || template === "TEMPLATE_12") && (shows?.synopsis || "").split(" ").length > 70 && (
                          <span className="see"
                            onClick={toggleDescription}
                          >
                            <Translate textKey={"see_more"} />
                          </span>
                        )}
                        {isExpanded && (template === "TEMPLATE_9" || template === "TEMPLATE_12") && (shows?.synopsis || "").split(" ").length > 70 && (
                          <span className="see"
                            onClick={toggleDescription}
                          >
                            <Translate textKey={"see_less"} />
                          </span>
                        )}
                      </p>
                    </div>
                    {/* <img
                  src={`${process.env.REACT_APP_IMAGE_URL}${shows?.banner}`}
                  alt="BgImage"
                /> */}
                    <div
                      className="bottomGradient"
                      style={{ background: (template === "TEMPLATE_9" || template === "TEMPLATE_12") ? "none" : "" }}
                    />
                  </div>
                </div>
              ) : (
                shows?.synopsis ?
                  <div className={`descTopContainer ${shows?.banner ? '' : 'no-image'}`}>
                    <div className={`${(template === "TEMPLATE_9" || template === "TEMPLATE_12") ? "topbannerDesc" : "topDesc"} ${shows?.banner ? '' : 'no-image'}`}>
                      <h1 className={`heading  ${template === "TEMPLATE_10" ? "gaia" : ""}  ${theme === "LIGHT" ? (shows?.banner ? "light-theme" : "light-noBg") : ""} `}> {projectInfo?.projectConfig?.pubid !== 50158 ? shows?.category_name : ""}</h1>
                      <p className="desc">
                        {(() => {
                          const synopsis = (template !== "TEMPLATE_9" && template !== "TEMPLATE_12")
                            ? shows?.synopsis
                            : isExpanded || (shows?.synopsis || "").split(" ").length <= 70
                              ? shows?.synopsis
                              : `${(shows?.synopsis || "").split(" ").slice(0, 70).join(" ")}...`;
                          if (isExpanded && isHTML(synopsis)) {
                            return <span dangerouslySetInnerHTML={{ __html: synopsis }} />;
                          }
                          return (
                            (template === "TEMPLATE_9" || template === "TEMPLATE_12") ? (
                              <span className="desc"
                                dangerouslySetInnerHTML={{
                                  __html: (synopsis || "").replace(/<br\s*\/?>/gi, "\n").replace(/<\/p>/gi, "\n").replace(/<[^>]+>/g, "").replace(/\n+/g, "\n")
                                }}
                              />
                            ) : (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: (synopsis || "").replace(/\n/g, "<br>")
                                }}
                              />
                            )
                          );
                        })()}
                        {!isExpanded && (template === "TEMPLATE_9" || template === "TEMPLATE_12") && (shows?.synopsis || "").split(" ").length > 70 && (
                          <span className="see"
                            onClick={toggleDescription}
                          >
                            <Translate textKey={"see_more"} />
                          </span>
                        )}
                        {isExpanded && (template === "TEMPLATE_9" || template === "TEMPLATE_12") && (shows?.synopsis || "").split(" ").length > 70 && (
                          <span className="see"
                            onClick={toggleDescription}
                          >
                            <Translate textKey={"see_less"} />
                          </span>
                        )}
                      </p>
                    </div>

                    <div
                      className="bottomGradient"
                      style={{ background: (template === "TEMPLATE_9" || template === "TEMPLATE_12") ? "none" : "" }}
                    />
                  </div> :


                  <div className="top">
                    <h1 className={`heading  ${template === "TEMPLATE_10" ? "gaia" : ""}  ${theme === "LIGHT" ? (shows?.banner ? "light-theme" : "light-noBg") : ""}`}> {shows?.category_name}</h1>
                    <p className="desc">
                      {isHTML(shows?.synopsis)
                        ? <span dangerouslySetInnerHTML={{ __html: shows?.synopsis }} />
                        : shows?.synopsis}
                    </p>
                  </div>
              )}

              <div className="wrapper">
                <div className="bottom">
                  <div className="itemsContainer" aria-label="Category Shows">
                    {shows?.category_name !== "Magazines" ? (
                      shows?.shows?.slice(0, sliceCount)?.map((item, index) => (
                        <div
                          className={thumbnailOrientation === `PORTRAIT` ? projectInfo?.projectConfig?.pubid === 50134 ? `items portrait rowCount6` : `items portrait ${rowItemsClass}` : `items landscape ${rowItemsClass}`}
                        >
                          {template === "TEMPLATE_10" ? (<GaiaCard
                            data={item}
                            key={index}
                            imageUrl={img}
                            season={false}
                            metaData={true}
                            type={type}
                            thumbnailOrientation={thumbnailOrientation}
                            categoryName={shows?.category_name}
                            tabIndex={0}
                            role="button"
                            aria-label={item?.show_title || "Show"}
                          />) : (<ShowCard
                            data={item}
                            key={index}
                            imageUrl={img}
                            season={false}
                            metaData={true}
                            type={type}
                            thumbnailOrientation={thumbnailOrientation}
                            categoryName={shows?.category_name}
                            tabIndex={0}
                            role="button"
                            aria-label={item?.show_title || "Show"}
                          />)}

                        </div>
                      ))
                    ) : (
                      shows?.shows?.slice(0, sliceCount)?.map((item, index) => (
                        <div
                          className={
                            shows?.category_name === "Magazines"
                              ? `items portrait ${rowItemsClass}`
                              : `items landscape ${rowItemsClass}`
                          }
                        >
                          <MagazineCard
                            data={item}
                            metaData={true}
                            cardHover={true}
                          />
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </>
  );
};

export default CommonPage;
